<sura-admin [linkActive] = "linkActive"></sura-admin>
<div class="container  pl-0 pr-0" >
    <div style="padding: 10px 0px"></div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
        <div class="card-header">
            Administraci&oacute;n de Representante
        </div>
       <form action="" class="card-body pr-0 pl-0">
           <div class="row justify-content-center">
               <div class="col-6">
	                <mat-label class="col-md-3 col-12 col-form-label lbl-srua-label2">Nro. Asamblea:</mat-label>
	                <mat-form-field class="col-md-9 col-12 lbl-srua-field" appearance="outline">
	                    <input matInput placeholder="" name="asamblea"
	                        [formControl]="nroAsambleaValidacion" [(ngModel)]="newAsamblea.id" required maxlength="6" (keypress)="fnKeyDownNumeric($event)" (keyup)="fnNumericMobile($event)"  (input)="fnInputMaxLength($event);" (change)="changeAsamblea()">
	                    <mat-error *ngIf="nroAsambleaValidacion.invalid">{{getErrorMessageNroAsamblea()}}</mat-error>

	                </mat-form-field>
	            </div>
   	            <div class="col-6 text-left pl-0 pt-4 pt-md-0 content-btn padding-top-butons-sura">
	           			<button mat-mini-fab color="primary" [disabled]="nroAsambleaValidacion.invalid" matSuffix   aria-label="Clear"
	                        (click)="buscarAsamblea()" matTooltip="Buscar Asamblea">
	                        <mat-icon>search</mat-icon>
	                    </button>
	            </div>
            </div>
            <div class="row justify-content-start">
            	<div class="col-6">
	                <mat-label class="col-md-3 col-12 col-form-label" style="margin-right:7px">Organizador:</mat-label>
	              <mat-form-field class="col-md-9 col-12" appearance="outline">
	                <input matInput disabled="disabled" value="{{newAsamblea.organizador.descripcion}}">
	              </mat-form-field>

                </div>
            </div>
        </form>
        <mat-divider></mat-divider>
         <div mat-dialog-actions class="d-flex justify-content-end mt-2 pr-2 padding-bottom-10">
                    <button mat-raised-button color="primary" (click)="openRegistroAsistente()" [disabled]="disableBtnAgregar"><mat-icon>person_add</mat-icon> &nbsp;&nbsp;Registrar Representante</button>
        </div>
        <div class="mat-elevation-z4">
            <div class="example-container ">
                <table mat-table [dataSource]="dataSource" aria-describedby="tabla de representantes">

                    <ng-container matColumnDef="NUMERODOCUMENTO" >
                        <th mat-header-cell *matHeaderCellDef scope="col"> NRO. DOCUMENTO   </th>
                        <td mat-cell *matCellDef="let element" class="text-center txt-sura-centred">{{element.tipoDocumento}}&nbsp;{{element.numeroDocumento}} </td>
                    </ng-container>

                    <!-- --nombres  -->
                    <ng-container matColumnDef="TITULAR">
                        <th mat-header-cell *matHeaderCellDef scope="col"> TITULAR    </th>
                        <td mat-cell *matCellDef="let element" class="text-left txt-sura-centred">{{element.nombres}}&nbsp;{{element.apellidos}}</td>
                    </ng-container>

                    <!-- --REPRESENTANTE   -->
                    <ng-container matColumnDef="REPRESENTANTE">
                        <th mat-header-cell *matHeaderCellDef scope="col"> REPRESENTANTE  </th>
                        <td mat-cell *matCellDef="let element" class="text-left txt-sura-centred"> {{element.descripcion}} </td>
                    </ng-container>

                    <!-- --OPCIONES   -->
                    <ng-container matColumnDef="OPCIONES">
                            <th mat-header-cell *matHeaderCellDef scope="col">OPCIONES</th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <button  matTooltip="Eliminar representante" mat-icon-button color="primary" type="button" (click)="showEliminarRepresentante(element)" [disabled]="disableBtnEliminar">
                                    <mat-icon aria-label="icon-button with a heart icon">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </table>
            </div>
            <div *ngIf="dataSource.data.length === 0" class="text-center text-secondary p-3">
                <span>No se encontraron resultados</span>
            </div>
            <mat-divider></mat-divider>
            <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>
